/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import VisibilityIcon from "@material-ui/icons/Visibility";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openDetailOrganizationReportPage, allowEdit }
) => (
  <>
    {allowEdit && (
      <OverlayTrigger
        overlay={<Tooltip id="folder-edit-tooltip">Detail Laporan</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-info btn-sm mx-2"
          onClick={() => {
            openDetailOrganizationReportPage(row.uuid);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-info">
            {/* <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          /> */}
            <VisibilityIcon />
          </span>
        </a>
      </OverlayTrigger>
    )}
  </>
);
